import { getCookie } from '../../utils/cookies';
import { waitForElem } from '../../utils/wait_for_elem';

waitForElem('a.image_large_view').then((elems: HTMLElement[]) => {
  elems?.forEach((image) => {
    image?.addEventListener('click', (e) => {
      e.preventDefault()
      const href = image.getAttribute('href')
      if (href) {
        image.setAttribute('src', href)
        image.setAttribute('target', '_blank')
        window.open(
          image.getAttribute('src'),
          "Image",
          `width=${image.getAttribute('width')},height=${image.getAttribute('height')}`
        )
      }
    })
  })
})

waitForElem('.share-button').then((elems: HTMLElement[]) => {
  elems?.forEach((btn) => {
    btn?.addEventListener('click', () => {
      const csrftoken = getCookie('csrftoken')
      const loc = window?.location?.href
      if (loc) {
        fetch('/update_share_count/', {
          headers: {
            'X-CSRFToken': csrftoken,
          },
          body: JSON.stringify({ 'url': loc }),
          method: "POST"
        })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error(err)
          })
      }
    });
  });
});
